import { anyPass, includes, isEmpty, isNil } from 'ramda'
import { getEnv } from 'sidecar-utilities'

export const showDefaultIcon = anyPass([
  isNil,
  includes('general_doctor_male.png'),
  includes('general_doctor_female.png'),
])

export const getPrimaryTaxonomySpecialty = (taxonomies = []) => {
  if (isNil(taxonomies) || isEmpty(taxonomies)) {
    return null
  }

  return taxonomies.reduce((providerSpecialty, { specialty, primary }) => {
    if (isNil(providerSpecialty)) {
      return specialty
    } else {
      return primary === 'T' ? specialty : providerSpecialty
    }
  }, null)
}

export const environment = `${getEnv()}-`
